module.exports = __webpack_public_path__ + "static/media/logo2.94ab8c7f.png";